<template>
  <li class="text-small-1 connect-to-chat pointer" @click="visitNotificationsPage" v-if="show">
    <div class="d-flex justify-content-between align-items-center">
      <div class="d-flex align-items-center">
        <i class="chat-typing-icon"></i>
        <span class="text-gradient bold pl-2">Connect to chat</span>
      </div>
      <i class="close-rounded-icon" @click.stop="onDismiss"></i>
    </div>
    <div class="content">
      <div class="text-secondary">Stay on top of things</div>
      <div class="d-flex align-items-center chat-icons mt-1">
        <img
          height="18"
          width="18"
          :src="app.iconUrl"
          :alt="app.name"
          :key="app.id"
          v-for="app in apps"
        />
      </div>
    </div>
  </li>
</template>

<script>
import * as R from 'ramda'
import { STORAGE_KEYS } from '@/constants/storage'
import SidebarStorageMixins from '@/mixins/SidebarStorageMixins'
import handleClickNavigation from '@/utils/handleClickNavigation'
import { getNotificationsPageRouteConfig } from '@/utils/navigationConfigs'

/**
 * This shows up as a dismissible widget in the sidebar. Clicking on this takes users to Notifications(App integrations) page
 */
export default {
  name: 'ConnectToChatWidget',
  props: ['orgId'],
  mixins: [SidebarStorageMixins],
  components: {},
  data() {
    return {
      show: !this.isDismissed(),
      apps: []
    }
  },
  computed: {},
  methods: {
    isDismissed() {
      return this.getSidebarFlag(STORAGE_KEYS.sidebar.flags.connectToChatWidgetDismissed)
    },
    visitNotificationsPage(event) {
      const location = getNotificationsPageRouteConfig({ orgId: this.orgId })
      handleClickNavigation.call(this, event, location)
    },
    onDismiss() {
      this.setSidebarFlag(STORAGE_KEYS.sidebar.flags.connectToChatWidgetDismissed, true)
      this.show = !this.isDismissed()
    },
    async refreshClients() {
      const clients = await this.$store.dispatch('getOauthClients', { orgId: this.orgId })
      const activeClients = clients.filter(
        client => client.areNotificationsEnabled || client.notificationsComingSoon
      )
      this.apps = R.take(3, activeClients).filter(x => x.iconUrl)
    }
  },
  mounted() {
    if (this.show) {
      this.refreshClients()
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/_styleConfigurations.scss';

.content {
  padding-left: 22px;
}
.chat-icons {
  gap: 15px;
  height: 18px;
}
.close-rounded-icon {
  @include dimension(19px, 19px);
}

.connect-to-chat {
  border-bottom: 1px solid $borderSecondary;
  padding-bottom: 16px;
  padding-top: 6px;
}
</style>
